import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickLinks = categories.slice(0, 6);
  const moreLinks = categories.slice(6, 12);

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link
              to="/"
              className="font-heading text-2xl text-background-50 tracking-tight whitespace-nowrap"
            >
              Hipobuy<span className="text-primary-400">Spreadsheet</span>
            </Link>
            <p className="mt-4 text-foreground-400 text-sm leading-relaxed max-w-sm">
              Votre guide complet pour maîtriser l&apos;automatisation de tableurs. Découvrez des outils, comparatifs et astuces pour optimiser votre productivité.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-base text-background-50 mb-4">Catégories</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-base text-background-50 mb-4">Plus</h4>
            <ul className="space-y-2.5">
              {moreLinks.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Article Links */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-base text-background-50 mb-4">Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/guide-hipobuy-spreadsheet"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Guide complet
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Hipobuy Spreadsheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Acheter maintenant
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-base text-background-50 mb-4">Newsletter</h4>
            <p className="text-foreground-400 text-sm mb-3">
              Recevez nos guides et astuces spreadsheet.
            </p>
            <form
              data-readdy-form=""
              action="https://readdy.ai/api/form/d8t4n84al24muhn2r340"
              method="POST"
              className="flex flex-col gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="votre@email.com"
                required
                className="w-full px-3 py-2.5 rounded-lg bg-foreground-800 border border-foreground-600 text-background-50 text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <button
                type="submit"
                className="w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                S&apos;inscrire
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-sm">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
            >
              Site principal
            </a>
            <Link
              to="/guide-hipobuy-spreadsheet"
              className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
            >
              Guide SEO
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}